import styled from "styled-components";

export const HeaderCenterMob = styled.div` 
  background:white;
  color:#3712B3;
  width: 85%;
  height: 35px;
  
  margin-left:30px;
  border-radius 50px;
  display: flex;
  justify-content:space-around;
  // align-items: center;

  @media (min-width: 768px) and (max-width: 1000px) {
		width:12rem
	}
	@media (max-width: 767px) {
		width:12rem
	}
`;

export const HeaderCenter = styled.div`
  background: white;
  color: #3712B3;  
  height: 35px;
  margin: auto;  
   border-radius 50px;
  display: flex;
  justify-content: space-around;
  align-items: center;  
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  top: 20%;
`;

export const SpinDivBox = styled.div`
  height: 30px;
  width: 30px;
`;